import React from "react";
import { Helmet } from "react-helmet";
import FirstAnimBlock from "./HomeContent/FirstAnimBlock";
import Stats from "./HomeContent/Stats";
import WhatWeDo from "./HomeContent/WhatWeDo";
import Services from "./HomeContent/Services";
import TechStack from "./HomeContent/TechStack";
import Industries from "./HomeContent/Industries";
import ContactUs from "./HomeContent/ContactUs";
import Blog from "./HomeContent/Blog";

import "./Home.css";

function Home() {
  return (
    <>
      <Helmet>
        <title>Com2Cloud — Cloud Development, IT Services & Digital Products</title>
        <meta
          name="description"
          content="Com2Cloud is a full-cycle cloud development company. We build, scale, and ship cloud-native applications using AWS, React, Node.js, Python, and 15+ technologies. Healthcare, agriculture, SaaS, and FinTech expertise."
        />
        <meta
          name="keywords"
          content="cloud development, AWS, Google Cloud, Azure, React, Node.js, Next.js, Python, React Native, mobile development, DevOps, Kubernetes, healthcare IT, precision agriculture, SaaS development, FinTech, full-cycle development, Com2Cloud"
        />
        <link rel="canonical" href="https://com2cloud.com" />
      </Helmet>
      <div className="landing">
        <section className="landing-section landing-section-hero">
          <div className="landing-content">
            <FirstAnimBlock />
          </div>
        </section>
        <section className="landing-section landing-section-tinted">
          <div className="landing-content">
            <Stats />
          </div>
        </section>
        <section className="landing-section landing-section-white">
          <div className="landing-content">
            <WhatWeDo />
          </div>
        </section>
        <section className="landing-section landing-section-tinted">
          <div className="landing-content">
            <Services />
          </div>
        </section>
        <section className="landing-section landing-section-white">
          <TechStack />
        </section>
        <section className="landing-section landing-section-tinted">
          <div className="landing-content">
            <Industries />
          </div>
        </section>
        <section className="landing-section landing-section-tinted">
          <div className="landing-content">
            <Blog />
          </div>
        </section>
        <section className="landing-section landing-section-white">
          <div className="landing-content">
            <ContactUs />
          </div>
        </section>
      </div>
    </>
  );
}

export default Home;
